import React from 'react';
import { BdsIcon } from '@/core/constants/webComponents';
import { useChannelIcon } from '@/core/hooks/useChannelIcon';

export interface ChannelIconProps {
  channel: string;
}


export const ChannelIcon: React.FC<ChannelIconProps> = ({ channel }) => {
  const channelData = useChannelIcon(channel);
  const iconUrl = channelData?.icons?.default;

  return (
    <span
      className="author-select__channel-icon"
      data-channel={channel}
      aria-hidden="true"
    >
      {iconUrl ? (
        <img 
          src={iconUrl} 
          alt={channel} 
          width={24} 
          height={24} 
          style={{ objectFit: 'contain' }}
        />
      ) : (
        <BdsIcon 
          theme="outline" 
          type="logo" 
          name={channel.toLowerCase()} 
          size="medium" 
        />
      )}
    </span>
  );
};